module.exports = __webpack_public_path__ + "static/media/kushner-inauguration.23284ac1.png";